import { useEffect, useState } from 'react';

import { DEV_MODE_COOKIE_NAME } from 'constants/cookies';
import { hasCookie } from 'utils/cookies';

/**
 * Hook that will tell if devmode is active
 */
export function useDevmode(): boolean {
	const [devmode, setDevmode] = useState<boolean>(false);

	useEffect(() => {
		setDevmode(hasCookie(DEV_MODE_COOKIE_NAME));
	}, []);

	return devmode;
}
